import {
  createContext,
  useCallback,
  useEffect,
  useState,
  type ReactNode,
  type MouseEvent,
} from "react";
import { usePathname } from '@/lib/router-navigation';
import { LoadingScreen } from "@/components/loading-screen/LoadingScreen";

function normalizePath(href: string) {
  const path = href.split("?")[0].split("#")[0];
  return path === "" ? "/" : path;
}

type NavigationLoadingContextValue = {
  onSidebarNavLinkClick: (href: string, event: MouseEvent<HTMLAnchorElement>) => void;
};

export const NavigationLoadingContext =
  createContext<NavigationLoadingContextValue | null>(null);

export const NavigationLoadingProvider = ({ children }: { children: ReactNode }) => {
  const pathname = usePathname();
  const [isNavigating, setIsNavigating] = useState(false);

  useEffect(() => {
    setIsNavigating(false);
  }, [pathname]);

  const onSidebarNavLinkClick = useCallback(
    (href: string, event: MouseEvent<HTMLAnchorElement>) => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }
      if (event.button !== 0) {
        return;
      }
      const target = normalizePath(href);
      const current = normalizePath(pathname ?? "/");
      if (target === current) {
        return;
      }
      setIsNavigating(true);
    },
    [pathname]
  );

  return (
    <NavigationLoadingContext.Provider value={{ onSidebarNavLinkClick }}>
      {children}
      {isNavigating && <LoadingScreen overlay />}
    </NavigationLoadingContext.Provider>
  );
};
